import makeStyles from '@mui/styles/makeStyles';
import InputAdornment from "@mui/material/InputAdornment";
import TextField from '@mui/material/TextField';
import {Eye, EyeOff} from "lucide-react";
import {get, noop} from "lodash";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {color} from "common/tokens";
import {fieldStyles} from "components/TextInput";

const useStyles = makeStyles({
  ...fieldStyles,
  reveal: {
    appearance: 'none',
    background: 'none',
    border: 'none',
    padding: 4,
    display: 'flex',
    alignItems: 'center',
    color: color.TEXT_MUTED,
    cursor: 'pointer',
  },
});

const PasswordInput = ({onAnswered = noop, question, value, error, autoComplete, placeholder, id, describedBy}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const [revealed, setRevealed] = useState(false);

  return (
    <TextField
      type={revealed ? 'text' : 'password'}
      value={value ?? ''}
      onChange={event => onAnswered(event.target.value)}
      variant={'outlined'}
      fullWidth
      error={Boolean(error)}
      autoComplete={autoComplete}
      placeholder={placeholder}
      id={id}
      inputProps={{
        'aria-describedby': describedBy,
        'aria-invalid': Boolean(error) || undefined,
        'aria-required': get(question, 'mandatory', false) || undefined,
      }}
      InputProps={{
        classes: {
          root: classes.root,
          focused: classes.focused,
          error: classes.error,
          disabled: classes.disabled,
          notchedOutline: classes.notchedOutline,
          input: classes.input,
        },
        endAdornment: (
          <InputAdornment position={'end'}>
            <button
              type={'button'}
              className={classes.reveal}
              aria-label={revealed ? t('hidePassword') : t('showPassword')}
              aria-pressed={revealed}
              onClick={() => setRevealed(!revealed)}
            >
              {revealed ? <EyeOff size={18}/> : <Eye size={18}/>}
            </button>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordInput;
